import React from 'react';
import { Text } from 'src/kit';

export const Title = props => (
  <Text as="p" mt={0} mb={20} color="textPrimary" fontSize={18} lineHeight={1} {...props} />
);
export const Label = props => <Text as="p" mb={5} color="textPrimary" fontSize={14} fontWeight="normal" {...props} />;
export const SectionLabel = props => <Text as="h2" color="textPrimary" fontSize={18} fontWeight="normal" {...props} />;
export const CustomText = props => <Text as="p" mb={10} color="primary" fontSize={14} fontWeight="light" {...props} />;
